import PeplinkConfiguration from "@components/vessels/Activation/CellularSection/PeplinkConfiguration";
import KitsNumbers from "@components/vessels/Activation/KitsNumbers/KitsNumbers";
import GeneralConfig from "@components/vessels/Configuration/GeneralConfig";
import StarlinkConfig from "@components/vessels/Configuration/StarlinkConfig/StarlinkConfig";
import Cybersecurity from "@components/vessels/Monitoring/Cybersecurity";
import Fortigate from "@components/vessels/Monitoring/Fortigate";
import InmarsatDp from "@components/vessels/Monitoring/InmarsatDp/InmarsatDp";
import Intelsat from "@components/vessels/Monitoring/Intelsat";
import OverviewSummary from "@components/vessels/Monitoring/OverviewSummary";
import Peplink from "@components/vessels/Monitoring/Peplink";
import Starlink from "@components/vessels/Monitoring/Starlink";
import Vouchers from "@components/vessels/Monitoring/Vouchers";
import VoucherToken from "@components/vessels/Monitoring/VoucherToken";
import YahsatServices from "@components/vessels/Monitoring/YahsatServices";
import { useSelector } from "react-redux";
import { checkPermission } from "./permissions";

export const getMonitoringTabs = (
	displaystarlink,
	displaycellular,
	displaycybersecurity,
	vesselId,
	displayintelsat,
	showPeplink,
	showStarlink,
	showIntelsat,
	showCyberSecurity,
	displayfortigate,
	showFortigate,
	displayVouchers,
	displayYahsatServices,
	showVouchers,
	showYahsatServices,
	showVoucherToken,
	showInmarsatDp,
) => [
	{
		name: "overview",
		label: "Overview Summary",
		content: <OverviewSummary />,
		display: true,
	},
	{
		name: "starlink",
		label: "Starlink",
		content: <Starlink />,
		display: (() => {
			if (!displaystarlink) return false;
			if (!displaystarlink && showStarlink) return false;
			if (displaystarlink && !showStarlink) return false;
			if (displaystarlink && showStarlink) return true;
			return null;
		})(),
		disabled: vesselId === undefined,
	},
	{
		name: "cellular",
		label: "Cellular",
		content: <Peplink />,
		disabled: vesselId === undefined,
		display: (() => {
			if (!displaycellular) return false;
			if (!displaycellular && showPeplink) return false;
			if (displaycellular && !showPeplink) return false;
			if (displaycellular && showPeplink) return true;
			return null;
		})(),
	},
	{
		name: "intelsat",
		label: "Intelsat",
		content: <Intelsat />,
		display: (() => {
			if (!displayintelsat) return false;
			if (!displayintelsat && showIntelsat) return false;
			if (displayintelsat && !showIntelsat) return false;
			if (displayintelsat && showIntelsat) return true;
			return null;
		})(),
		disabled: vesselId === undefined,
	},
	{
		name: "cybersecurity",
		label: "Cybersecurity",
		content: <Cybersecurity />,
		disabled: vesselId === undefined,
		display: showCyberSecurity,
	},
	{
		name: "fortigate",
		label: "Fortigate",
		content: <Fortigate />,
		display: showFortigate,
		disabled: vesselId === undefined,
	},

	{
		name: "yahsatServices",
		label: "Yahsat Services",
		content: <YahsatServices />,
		display: showYahsatServices,
		disabled: vesselId === undefined,
	},
	{
		name: "vouchers",
		label: "Vouchers Services",
		content: <Vouchers />,
		display: showVouchers,
		disabled: vesselId === undefined,
	},
	{
		name: "voucherToken",
		label: "Voucher Token",
		content: <VoucherToken />,
		display: showVoucherToken,
		disabled: vesselId === undefined,
	},
	{
		name: "InmarsatDp",
		label: "Inmarsat DP",
		content: <InmarsatDp />,
		display: showInmarsatDp,
		disabled: vesselId === undefined,
	},
];

export const getActivationTabs = (displaystarlink, displaycellular, showStarlink, showPeplink) => {
	const { token, permissions } = useSelector((state) => state.auth.user);
	const vesselsSite = permissions.find((resource) => resource.resource_name === "vessels_site");
	const authorizedPermissions = vesselsSite?.permissions || [];

	const canAddPeplinkConfiguration = checkPermission(
		authorizedPermissions,
		"add peplink configuration",
	);

	return [
		// {
		//   name: "overviewVessel",
		//   label: "Overview Summary",
		//   content: <OverviewVessel />,
		//   display: true,
		// },
		{
			name: "Kitsstarlink",
			label: "Starlink",
			content: <KitsNumbers />,
			display: (() => {
				if (!displaystarlink) return false;
				if (!displaystarlink && showStarlink) return false;
				if (displaystarlink && !showStarlink) return false;
				if (displaystarlink && showStarlink) return true;
				return null;
			})(),
		},
		{
			name: "activationcellular",
			label: canAddPeplinkConfiguration ? "Cellular" : null,
			content: canAddPeplinkConfiguration ? <PeplinkConfiguration /> : "No Access",
			disabled: !canAddPeplinkConfiguration, // Disable tab if permission is missing
			display: (() => {
				if (!displaycellular) return false;
				if (!displaycellular && showPeplink) return false;
				if (displaycellular && !showPeplink) return false;
				if (displaycellular && showPeplink) return true;
				return null;
			})(),
		},
	];
};
export const getConfigurationTabs = () => [
	{
		name: "generalconfig",
		label: "General Config",
		content: <GeneralConfig />,
		display: true,
	},
	{
		name: "starlinkconfig",
		label: "Starlink",
		content: <StarlinkConfig />,
		display: true,
	},
	// {
	//   name: "thurayaconfig",
	//   label: "Thuraya Config",
	//   content: "no data",
	//   display: true,
	// },
	// {
	//   name: "billingconfig",
	//   label: "Billing",
	//   content: "no data",
	//   display: true,
	// },
];
